export type CategoryNavigationMode = 'base' | 'front'

export interface CategoryNavigationQuery {
  id?: unknown
  backCid?: unknown
  form?: unknown
}

export interface CategoryNavigationItem {
  id: number | string
  slug: string
}

export interface CategoryBreadcrumbOptions {
  mode: CategoryNavigationMode
  source?: string
}

/** Keep the category ID family that created the current category result. */
export const resolveCategoryNavigationMode = (
  query: CategoryNavigationQuery
): CategoryNavigationMode => {
  if (query.backCid !== undefined && query.backCid !== null && query.backCid !== '') {
    return 'base'
  }

  return 'front'
}

/** Build an internal category URL without coupling it to the current origin/protocol. */
export const buildCategoryBreadcrumbPath = (
  category: CategoryNavigationItem,
  options: CategoryBreadcrumbOptions
): string => {
  const params = new URLSearchParams()
  const idKey = options.mode === 'base' ? 'backCid' : 'id'

  params.set(idKey, String(category.id))
  params.set('form', 'category')
  if (options.source) {
    params.set('source', options.source)
  }

  return `/category/${category.slug}?${params.toString()}`
}
